// extracted by mini-css-extract-plugin
export default {"lastModifiedDateTime":"LowActivityMerchantDataLake_lastModifiedDateTime__4RTQB"};